import { Control, Controller } from "react-hook-form";
import { PaymentTransactionType, PayStudentDebtType } from "../../../types/Finance";
import { MinusIcon } from "@radix-ui/react-icons";
import { Card, Flex, Heading, IconButton, Box,Text } from "@radix-ui/themes";
import { remove } from "lodash";
import DateFieldComponent from "../../../components/inputs/Datefield/DatefieldComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { DragAndDropFileUpload } from "../../../components/inputs/FileUpload/DragAndDropFileUpload";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";

interface IProps {
    index: number;
    remove: any;
    control: Control<PayStudentDebtType>;
    errors: any;
    field?: any;
    watch:any,
    paymentMethods:any[]
    viewMode?:boolean
}
export const PaymentTransactionsForm : React.FC<IProps> = ({ index, remove, control, errors, watch,paymentMethods,viewMode= false}) => {
  return (
    <Card size='2' style={{ padding: '20px', marginBottom: '16px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
            <Flex direction='column' gap='4'>
                <Flex align='center' justify='between'>
                    <Heading size='2' weight='bold'>Pagamento {index + 1}</Heading>
                    <IconButton
                        color='red'
                        size='2'
                        onClick={(e: any) => {
                            e.preventDefault();
                            remove(index);
                        }}
                    >
                        <MinusIcon width="18" height="18" />
                    </IconButton>
                </Flex>
                <Flex gap='4' direction='column'>
                <Box style={{width:"100%"}}>
                  <DateFieldComponent 
                      name={`paymentTransation.${index}.date` as const}
                      composedName={{parent:`paymentTransation.${index}`, prop:'date'} }
                      label="Data de pagamento"
                      control={control}
                      errors={errors}
                      style={{ width: '100%' }}
                      required={true}
                  />
                {errors.paymentTransation?.[index]?.date && (
                  <Text color="red" size="1">{`${errors.paymentTransation[index]?.date?.message}`}</Text>
                )}
                </Box>
              <Box style={{ width: "100%" }}>
                <TextFieldComponent
                  name={`paymentTransation.${index}.amountPaid` as const}
                  label="Valor pago"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: 'Valor a pago' }}
                  required={true}
                />
                {errors.paymentTransation?.[index]?.amountPaid && (
                  <Text color="red" size="1">{`${errors.paymentTransation[index]?.amountPaid?.message}`}</Text>
                )}
              </Box>
              <Box style={{ width: "100%" }}>
                <SelectComponent 
                  name={`paymentTransation.${index}.idPaymentMethod` as const}
                  label="Forma de pagamento"
                  control={control}
                  errors={errors}
                  style={{ width: '100%' }}
                  options={paymentMethods?.map((paymentMethod) => ({
                  value:  paymentMethod?.id?? "",
                  label: paymentMethod?.description ?? ""
                }))}
              />
                 {errors.paymentTransation?.[index]?.idPaymentMethod && (
                  <Text color="red" size="1">{`${errors.paymentTransation[index]?.idPaymentMethod?.message}`}</Text>
                )}
              </Box>
              <Box style={{ width: "100%" }}>
                <Text as="label">Comprovativo</Text>
                <Controller
                        name={`paymentTransation.${index}.file` as const}
                        control={control}
                        render={({ field }) => (
                          <DragAndDropFileUpload
                            onFileDrop={(file) => {
                              field.onChange(file);
                            }}
                            accept="*"
                            selectedFile={field.value}
                            isReadOnly ={viewMode}
                          />
                          
                        )}
                      />
                      {errors?.paymentTransation?.[index]?.file && (
                        <Text color="red" size="1" style={{ marginTop: '5px' }}>
                          {`${errors?.paymentTransation?.[index]?.file?.message}`}
                        </Text>
                      )}
              </Box> 
                </Flex>
            </Flex>
        </Card>  )
}
